import React, {useEffect, useMemo} from 'react';

import styles from './MobileModal.module.css'
import stylesWindow from './MobileWindowModal.module.css'

import {cn} from "../../../utils/cn.ts";
import {Icon} from "../../General/Icon/Icon.tsx";
import {createPortal} from "react-dom";


interface Props {
    isOpen: boolean
    close: () => void
    children: React.ReactNode
    title?: string|React.ReactNode
    type?: 'fullScreen' | 'window'
}

export const MobileModal: React.FC<Props> = ({children, close, isOpen = false, title = '', type = 'fullscreen'}) => {
    const isWindow = useMemo(() => type === 'window', [type]);
    const isFullscreen = useMemo(() => type === 'fullscreen', [type]);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        
        if (isOpen) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };

    }, [isOpen]);

    const headerNode = document.querySelector('.header')

    return (<>
        {isOpen && (<>
            {isFullscreen && (
                <div className={cn(styles.wrapper, isOpen && styles.open)}>
                    <div className={styles.header}>
                        <div>{title}</div>
                        <div className={styles.closeBtn} onClick={close}>
                            <Icon
                                name='close'
                                width={14}
                                height={14}
                            />
                        </div>
                    </div>
                    <div className={styles.body}>
                        {children}
                    </div>
                </div>
            )}

            {isWindow && headerNode && createPortal(
                <div className={cn(stylesWindow.wrapper, isOpen && stylesWindow.open)}>
                    <div className={stylesWindow.closeBtn} onClick={close}>
                        <Icon
                            name='close'
                            width={18}
                            height={18}
                        />
                    </div>
                    <div className={stylesWindow.body}>
                        {children}
                    </div>
                </div>
                , headerNode)}
        </>)}
    </>);
};